import { AvatarModeStyled, AvatarStyled, CardContent, CardImageContainer, CardTitle, HomeTitleSection, LogoImage, MainContainer, MainDescription, MainTitle, RankedsImage, SecondarySection, TitleTopbrawl, ToopbrawlTitleContainer } from "./home.styles";
import { AvatarGroup, Typography, useMediaQuery } from "@mui/material";
import { Footer } from "../../components/footer/footer";
import { screenBreackpoints } from "../../theme";
import { useTranslation } from "react-i18next";
import { SeoHelmet } from "../../components/seo-helmet/seo-helmet";
import { CardBtn, CardContainer, LinkStyled, PageContainer } from "../../components/base-components/base-componets";
import { getUrlWithLang } from "../../routes/routes.functions";
import { useLanguage } from "../../hooks/language/language";
import { APP_ROUTES } from "../../routes/routes.constants";
import { getBrawlerImgSrc, getImageSrc, getModeColor, ImageType } from "../../shared/functions";


export const Home: React.FC = () => {
  const isMobile = useMediaQuery(`(max-width:${screenBreackpoints.mobile})`);
  const { t } = useTranslation();
  const { getLanguage } = useLanguage();
  const language = getLanguage()

  const title = t("PAGES.HOME.SEO.TITLE")
  const description = t("PAGES.HOME.SEO.DESCRIPTION")
  const keywords = t("PAGES.HOME.SEO.KEYWORDS")

  const getAvatars = (brawlers: string[]) => {
    return brawlers.map(name => (
      <AvatarStyled
        key={name}
        src={getBrawlerImgSrc(ImageType.AVATAR, name)}
        alt={`Avatar ${name}`}
      />
    ));
  };

  const getModes = (modes: string[]) => {
    return modes.map(name => (
      <AvatarModeStyled
        backgroundColor={getModeColor(name)}
        key={name}
        src={getImageSrc(`/images/modes/${name}.webp`)}
        alt={`${t("SHARED.MODE")} ${name}`}
      />
    ));
  };

  return (
    <>
      <SeoHelmet title={"Topbrawl - " + title} description={description} keywords={keywords} />
      <PageContainer isMobile={isMobile}>
        <MainContainer>
          <HomeTitleSection>
            <LogoImage
              component="img"
              alt="Topbrawl Logo"
              src={getImageSrc(`/images/logo/main-logo.webp`)}
            />
            <ToopbrawlTitleContainer>
              <TitleTopbrawl>
                Topbrawl
              </TitleTopbrawl>
            </ToopbrawlTitleContainer>
          </HomeTitleSection>
          <MainTitle component="h1">
            {title}
          </MainTitle>
          <MainDescription>
            {description}
          </MainDescription>
          <SecondarySection>
            <LinkStyled
              to={getUrlWithLang(language, `${APP_ROUTES.RANKEDS}`)}
              aria-label={t("SHARED.RANKEDS")} >
              <CardBtn>
                <CardContainer>
                  <CardContent>
                    <CardTitle component="h2">
                      {t("PAGES.HOME.CARD_RANKEDS.TITLE")}
                    </CardTitle>
                    <Typography>
                      {t("PAGES.HOME.CARD_RANKEDS.DESCRIPTION")}
                    </Typography>
                    <CardImageContainer>
                      <RankedsImage
                        component="img"
                        alt={t("SHARED.RANKEDS")}
                        src={getImageSrc(`/images/home/ranked.webp`)}
                      />
                    </CardImageContainer>
                  </CardContent>
                </CardContainer>
              </CardBtn>
            </LinkStyled>
            <LinkStyled
              to={getUrlWithLang(language, `${APP_ROUTES.BRAWLERS}`)}
              aria-label={"Brawlers"} >
              <CardBtn>
                <CardContainer>
                  <CardContent>
                    <CardTitle component="h2">
                      {t("PAGES.HOME.CARD_BRAWLERS.TITLE")}
                    </CardTitle>
                    <Typography>
                      {t("PAGES.HOME.CARD_BRAWLERS.DESCRIPTION")}
                    </Typography>
                    <CardImageContainer>
                      <AvatarGroup>
                        {getAvatars(["SHELLY", "DYNAMIKE", "COLT", "KENJI"])}
                      </AvatarGroup>
                      <AvatarGroup sx={{ marginTop: "-20px" }}>
                        {getAvatars(["LEON", "FINX", "MORTIS", "FANG"])}
                      </AvatarGroup>
                    </CardImageContainer>
                  </CardContent>
                </CardContainer>
              </CardBtn>
            </LinkStyled>
            <LinkStyled
              to={getUrlWithLang(language, `${APP_ROUTES.MODES}`)}
              aria-label={t("SHARED.MODE")} >
              <CardBtn>
                <CardContainer>
                  <CardContent>
                    <CardTitle component="h2">
                      {t("PAGES.HOME.CARD_MODES.TITLE")}
                    </CardTitle>
                    <Typography>
                      {t("PAGES.HOME.CARD_MODES.DESCRIPTION")}
                    </Typography>
                    <CardImageContainer>
                      <AvatarGroup>
                        {getModes(["SOLO_SHOWDOWN", "KNOCKOUT", "GEM_GRAB", "TRIO_SHOWDOWN"])}
                      </AvatarGroup>
                      <AvatarGroup sx={{ marginTop: "-20px" }}>
                        {getModes(["BRAWL_BALL", "HOT_ZONE", "HEIST", "UNKNOWN"])}
                      </AvatarGroup>
                    </CardImageContainer>
                  </CardContent>
                </CardContainer>
              </CardBtn>
            </LinkStyled>
          </SecondarySection>
        </MainContainer>
        <Footer />
      </PageContainer >
    </>
  );
}
